__turbopack_context__.v({
  "counter": "p_VqYW_counter",
  "root": "p_VqYW_root",
});
